import Icon from './icon';
export default {
  Icon,
  title: 'Skeleton',
  hotkey: 'w'
};